import React from "react"
import styled from "@emotion/styled"
import Section from "src/components/Section"
import Grid from "src/components/Grid"
import ScrollEntrance from "src/components/ScrollEntrance"

import { mq, globals } from "src/styles"

const IFrameSection = styled(Section)`
  width: 100%;
  height: 100%;

  div {
    width: 100%;
    height: 100%;
  }

  ${mq.largeAndBelow} {
    ${globals.verticalSpacing("padding-bottom")}
  }

  ${props => `
    min-height: ${props.mobileHeight}px;
    ${mq.largeAndUp} {
        min-height: ${props.desktopHeight}px;
    }
  `}
  ${mq.mediumAndBelow} {
    ${({ hideMobile }) => (hideMobile && "display: none")}
  }
  ${mq.largeAndUp} {
    ${({ hideDesktop }) => (hideDesktop && "display: none")}
  }
`

const IFrameWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`

const IFrameEl = styled.iframe`
  overflow: hidden;
  width: 100%;
  height: 100%;
`

const Iframe = ({
  _key,
  className,
  width = "default",
  isFirstSection,
  theme,
  prevTheme,
  nextTheme,
  src,
  mobileHeight,
  desktopHeight,
  hideMobile,
  hideDesktop,
}) => {
  const fullWidth = width === "fullWidth"

  return (
    <>
      <IFrameSection
        key={_key}
        className={className}
        setTheme={theme}
        prevTheme={prevTheme}
        nextTheme={nextTheme}
        isFirstSection={isFirstSection}
        padded={!fullWidth}
        mobileHeight={mobileHeight}
        desktopHeight={desktopHeight}
        hideMobile={hideMobile}
        hideDesktop={hideDesktop}
      >
        <Grid small="[1]" medium="m [1] m" large="[1]">
          <ScrollEntrance>
            <IFrameWrapper>
              <IFrameEl seamless={true} src={src} />
            </IFrameWrapper>
          </ScrollEntrance>
        </Grid>
      </IFrameSection>
    </>
  )
}

export default Iframe
